export default {
  computed: {
    pageIsOnTwoOrMore() {
      return (this.$route.query.page && this.$route.query.page > 1)
      || (this.$route.params.pageNumber && this.$route.params.pageNumber > 1);
    },
  },
};
